import { widgetState } from '../../store/customizations/index'

export const radioTemplate = () => {
  return `
    <label style="margin-bottom: 0" class="yotpo-radio-label">
        <input class="yotpo-radio-label-input yotpo-selling-plan-radio-label {{checkedClassFn}}"
               data-selling-plan-name="{{inputAttributes.data}}"
               type="radio"
               name="{{inputAttributes.name}}"
               value="{{value}}" {{{checkedFn}}}>
        <span style="cursor:pointer" class="yotpo-radio-label-text">{{text}}</span>
    </label>
    <style>
        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label .yotpo-radio-label-text {
          font-size: ${widgetState.customizations.styles.fontSize.sellingPlans.name};
          font-family: ${widgetState.customizations.styles.fontFamily.name};
          font-style: normal;
          font-weight: ${widgetState.customizations.styles.fontFamily.weight || 600};
          color: ${widgetState.customizations.styles.colors.text.primary};
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-input {
          margin: auto;
          cursor:pointer;
          min-height: auto;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-input:checked ~ .yotpo-radio-label-text:after {
          background-size: cover;
          background-position: center;
          background-image: url('${widgetState.customizations.styles.selectedRadio.backgroundImageUrl}');
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-input {
          appearance: none;
          -webkit-appearance: none;
          border: none;
          background: none;
          margin-right: 15px;
          width: 11px;
          height: 11px;
          padding: 0;
          border-radius: 0;
          display: inline-block;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-text:after {
          display: block;
          position: absolute;
          top: 1px;
          left: -17px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-text:before {
          display: block;
          position: absolute;
          top: ${widgetState.customizations.isReadOnly ? '1px' : '2px'};
          left: -17px;
          width: ${widgetState.customizations.isReadOnly ? '12px' : '14px'};
          height: ${widgetState.customizations.isReadOnly ? '12px' : '14px'};
          border-radius: 50%;
          border: 2px solid #416142;
          background-color: #ffffff;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plan-radio-label:after, .yotpo-select-radio-label:after {
          width: 9px;
          height: 9px;
          border-radius: 15px;
          background-color: ${widgetState.customizations.styles.notSelectedRadio.backgroundColor};
          content: '';
          display: flex;
          visibility: visible;
          border: 3px solid ${widgetState.customizations.styles.notSelectedRadio.backgroundColor};
          box-shadow: 0 0 0 1px ${widgetState.customizations.styles.radioButton.outerColor};
          box-sizing: content-box !important;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plan-radio-label:checked:after, .yotpo-select-radio-label:checked:after {
          background-color: ${widgetState.customizations.styles.radioButton.innerColor};
        }
    </style>`
}
